<template>
  <!-- 权限管理 -->
  <div class="layout">
    <div class="menu">
      <Menu topIndex="system"></Menu>
    </div>
    <div class="leftSide">
      <LeftSideBar current="system" leftIndex="authority"></LeftSideBar>
    </div>
    <div id="authorityBox" class="base-content">
      <div class="left-tree">
        <el-tree
          v-if="opentree"
          :props="props"
          ref="mainTree"
          :load="loadNode"
          highlight-current
          :expand-on-click-node="false"
          node-key="id"
          @node-click="listClick"
          lazy
        >
        </el-tree>
      </div>
      <div class="rightBox" style="margin-top: 0">
        <!-- 上方按钮 -->
        <div class="button-box">
          <el-button
            type="text"
            icon="el-icon-folder"
            size="small"
            @click="nodeEditSave"
            >保存</el-button
          >
          <el-button
            type="text"
            icon="el-icon-plus"
            size="small"
            @click="createAuthority()"
            >新建子权限</el-button
          >
          <el-button
            type="text"
            icon="el-icon-delete"
            size="small"
            @click="deletePre()"
            >删除</el-button
          >
        </div>
        <!-- 上方按钮end -->
        <div class="contentBox">
          <div
            v-show="!getAuthority.id || getAuthority.id <= 0"
            class="tip-text"
          >
            请选择资源库
          </div>
          <!-- 新建子权限弹窗 -->
          <el-dialog
            title="新建子权限"
            :visible.sync="createAuthorityDialog"
            width="600px"
          >
            <el-form
              ref="createAuthorityForm"
              :model="createAuthorityForm"
              :rules="createAuthorityRules"
            >
              <el-form-item label="上级权限:" label-width="90px">
                <el-input
                  type="text"
                  placeholder="未选择权限"
                  :disabled="true"
                  v-model="currentParent"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="权限名称:"
                label-width="90px"
                prop="permDesc"
              >
                <el-input
                  v-model="createAuthorityForm.permDesc"
                  type="text"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="英文名称:"
                label-width="90px"
                prop="permName"
              >
                <el-input
                  v-model="createAuthorityForm.permName"
                  type="text"
                ></el-input>
              </el-form-item>
              <el-form-item label="类型：" label-width="90px" prop="type">
                <el-select v-model="createAuthorityForm.type" clearable>
                  <el-option
                    v-for="item in typeList"
                    :key="item.code"
                    :value="item.value"
                    :label="item.label"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="权限顺序：" label-width="90px">
                <el-input
                  v-model="createAuthorityForm.orderField"
                  style="max-width: 400px"
                ></el-input>
              </el-form-item>
              <el-form-item label="链接：" label-width="90px">
                <el-input
                  v-model="createAuthorityForm.url"
                  style="max-width: 400px"
                ></el-input>
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button type="primary" @click="onCreate('createAuthorityForm')"
                >确 定</el-button
              >
              <el-button @click="createAuthorityDialog = false"
                >取 消</el-button
              >
            </span>
          </el-dialog>
          <!-- 删除确认弹窗 -->
          <el-dialog
            title="删除分类"
            :visible.sync="deletePreDialog"
            width="600px"
          >
            <div>确定删除该分类</div>
            <span slot="footer" class="dialog-footer">
              <el-button type="primary" @click="onDelete">确 定</el-button>
              <el-button @click="deletePreDialog = false">取 消</el-button>
            </span>
          </el-dialog>
          <!-- 分类编辑显示内容 -->
          <el-form
            :data="authorityContentForm"
            v-show="getAuthority.id && getAuthority.id > 0"
            class="sortEditForm"
          >
            <el-form-item label="ID：" label-width="200px">
              <p>{{ authorityContentForm.id }}</p>
            </el-form-item>

            <el-form-item label="权限名称：" label-width="200px">
              <el-input
                v-model="authorityContentForm.permDesc"
                style="max-width: 400px"
              ></el-input>
            </el-form-item>
            <el-form-item label="英文名称：" label-width="200px">
              <el-input
                v-model="authorityContentForm.permName"
                style="max-width: 400px"
              ></el-input>
            </el-form-item>
            <el-form-item label="类型：" label-width="200px">
              <el-select v-model="authorityContentForm.type" clearable>
                <el-option
                  v-for="item in typeList"
                  :key="item.code"
                  :value="item.value"
                  :label="item.label"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="权限顺序：" label-width="200px">
              <el-input
                v-model="authorityContentForm.orderField"
                style="max-width: 400px"
              ></el-input>
            </el-form-item>
            <el-form-item label="链接：" label-width="200px">
              <el-input
                v-model="authorityContentForm.url"
                style="max-width: 400px"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Menu from "../../menu/menu.vue";
import LeftSideBar from "../../menu/leftSideBar.vue";
import cookies from "vue-cookies";
import $ from "jquery";
export default {
  data: function () {
    return {
      getAuthority: {},
      dataList: [],
      currentParent: "",
      opentree: true,
      typeList: [
        {
          label: "栏目",
          value: 10,
        },
        {
          label: "菜单",
          value: 20,
        },
        {
          label: "按钮",
          value: 30,
        },
      ],
      authorityContentForm: {
        id: "",
        permName: "",
        permDesc: "",
        type: "",
        parentId: "",
        orderField: "",
        url: "",
      },

      createAuthorityForm: {
        id: "",
        permName: "",
        permDesc: "",
        type: "",
        parentId: "",
        orderField: "",
        url: "",
      },
      props: {
        label: "permDesc",
        children: "children",
        isLeaf: "isLeaf",
      },
      // 弹窗组
      createAuthorityDialog: false,
      deletePreDialog: false,
      lockPreDialog: false,
      reorderPreDialog: false,
      createAuthorityRules: {
        permName: [
          { required: true, message: "请输入英文名称", trigger: "blur" },
        ],
        permDesc: [{ required: true, message: "请输入名称", trigger: "blur" }],
        type: [{ required: true, message: "请选择类型", trigger: "blur" }],
      },
    };
  },
  components: {
    Menu,
    LeftSideBar,
  },
  mounted() {
    // 统一验证token
    var currentToken = cookies.get("token");
    $.ajaxSetup({
      headers: {
        AuthorizationToken: currentToken,
      },
      complete: function (xhr) {
        if (xhr.responseJSON.code == 401) {
          window.location.href = "/";
        }
      },
    });
  },
  methods: {
    // 树形结构加载
    loadNode(node, resolve) {
      let that = this;
      this.getAuthority = node;
      $.ajax({
        url: "/zyk/c/auth/permInfo/list",
        type: "GET",
        //contentType: 'application/json;charset=utf-8',
        dataType: "json",
        // data: { ids: ids.toString() },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.reload();
          }
        },
        success: function (data) {
          if (node.level == 0) {
            return resolve([{ permDesc: "资源库权限", id: "-1" }]);
          } else if (node.level == 1) {
            that.dataList = data.obj;
            return resolve(that.dataList);
          } else {
            return resolve(node.data.children);
          }
        },
      });
    },
    // 点击树
    listClick(node) {
      let that = this;
      that.getAuthority = node;
      if (node.id == -1) {
        that.authorityContentForm = {
          id: "-1",
          permDesc: "百科数据资源库",
        };
      } else {
        that.authorityContentForm = node;
      }
    },
    // 修改节点保存
    nodeEditSave() {
      let that = this;
      $.ajax({
        url: "/zyk/c/auth/permInfo/update",
        type: "POST",
        //contentType: 'application/json;charset=utf-8',
        dataType: "json",
        data: that.authorityContentForm,
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.reload();
          }
        },
        success: function (data) {
          if (data.code == 200) {
            that.$message({
              message: "修改成功",
              duration: 2000,
              showClose: true,
              type: "success",
              offset: 100,
            });
          } else {
            that.$message({
              message: data.msg,
              duration: 0,
              showClose: true,
              type: "error",
              offset: 100,
            });
          }
        },
      });
    },
    // 创建子权限
    createAuthority() {
      let that = this;
      that.createAuthorityForm = {
        id: "",
        permName: "",
        permDesc: "",
        type: "",
        parentId: "",
        orderField: "",
        url: "",
      };
      that.currentParent = that.authorityContentForm.permDesc;
      if (that.authorityContentForm.id == "-1") {
        that.createAuthorityForm.parentId = "";
      } else {
        that.createAuthorityForm.parentId = that.authorityContentForm.id;
      }
      this.createAuthorityDialog = true;
      that.getAuthority = {};
    },
    // 提交创建
    onCreate(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let that = this;
          $.ajax({
            url: "/zyk/c/auth/permInfo/add",
            type: "POST",
            //contentType: 'application/json;charset=utf-8',
            dataType: "json",
            data: that.createAuthorityForm,
            error: function (xhr) {
              if (xhr.status == 401) {
                window.location.reload();
              }
            },
            success: function (data) {
              if (data.code == 200) {
                that.$message({
                  message: "权限创建成功",
                  duration: 2000,
                  showClose: true,
                  type: "success",
                  offset: 100,
                });

                // 刷新树结构
                var updateNode = {}
                if(that.$refs.mainTree.getNode(that.authorityContentForm).level>1){
                    updateNode = that.$refs.mainTree.getNode(data.obj.parentId).data
                }else{
                    updateNode = that.authorityContentForm
                }
                $.ajax({
                  url: "/zyk/c/auth/permInfo/list",
                  type: "GET",
                  data: { parentId: updateNode.id },
                  dataType: "json",
                  error: function (xhr) {
                    if (xhr.status == 401) {
                      window.location.reload();
                    }
                  },
                  success: function (response) {
                    updateNode.children = response.obj
                    that.$refs.mainTree.updateKeyChildren(
                      updateNode.id,
                      updateNode
                    );
                  },
                });


                // that.opentree = false;
                // that.$nextTick(() => {
                //   that.opentree = true;
                // });
                that.createAuthorityDialog = false;
              } else {
                that.$message({
                  message: data.msg,
                  duration: 0,
                  showClose: true,
                  type: "error",
                  offset: 100,
                });
              }
            },
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    deletePre() {
      let that = this;
      if (!that.getAuthority.id || that.getAuthority.id == "-1") {
        that.$message({
          message: "请选中权限再进行删除操作",
          duration: 2000,
          showClose: true,
          type: "error",
          offset: 100,
        });
      } else {
        this.deletePreDialog = true;
      }
    },
    // 删除
    onDelete() {
      let ids = this.authorityContentForm.id;
      let that = this;
      // that.noClick = true;
      $.ajax({
        url: "/zyk/c/auth/permInfo/remove",
        type: "POST",
        //contentType: 'application/json;charset=utf-8',
        dataType: "json",
        data: { ids: ids },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.reload();
          }
        },
        success: function (data) {
          if (data.code == 200) {
            that.$message({
              message: "删除成功",
              duration: 2000,
              showClose: true,
              type: "success",
              offset: 100,
            });

            // 刷新树结构
            var updateNode = {}
            if(that.$refs.mainTree.getNode(that.authorityContentForm).level>1){
                updateNode = that.$refs.mainTree.getNode(that.authorityContentForm.parentId).data
            }else{
                updateNode = that.authorityContentForm
            }
            $.ajax({
              url: "/zyk/c/auth/permInfo/list",
              type: "GET",
              data: { parentId: updateNode.id },
              dataType: "json",
              error: function (xhr) {
                if (xhr.status == 401) {
                  window.location.reload();
                }
              },
              success: function (response) {
                updateNode.children = response.obj
                that.$refs.mainTree.updateKeyChildren(
                  updateNode.id,
                  updateNode
                );
              },
            });
            that.deletePreDialog = false;
          } else {
            that.$message({
              message: data.msg,
              duration: 0,
              showClose: true,
              type: "error",
              offset: 100,
              onClose: function () {
                // that.noClick = false;
              },
            });
          }
        },
      });
    },
  },
};
</script>

<style>
#authorityBox {
  overflow: auto;
}
#authorityBox::after {
  content: "";
  display: inline-block;
  clear: both;
}

.rightBox {
  float: right;
  width: calc(100% - 250px);
}

.rightBox .tip-text {
  margin-left: 20px;
}

.rightBox .button-box {
  margin-bottom: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
}
.information {
  width: 100%;
}

.el-dialog .el-form {
  padding: 10px 50px;
}

.el-select-dropdown__list {
  padding: 10px !important;
}

.reorderPreDialog {
  text-align: center;
}

.reorderPreDialog .el-input {
  display: inline;
}
.reorderPreDialog input {
  width: 100px;
}
.reorderPreDialog .red {
  color: red;
}
.sortEditForm label {
  text-align: left;
}

.sortEditForm {
  padding: 10px 50px;
}

.sortEditForm .el-form-item {
  display: block;
  margin: 5px 0;
}
</style>